import BaseMapList from './BaseMapList'

export default BaseMapList
